// extracted by mini-css-extract-plugin
export default {"PermissionContainerDiv":"RolePermissionList_PermissionContainerDiv__r5rJk"};